import { createFileRoute, Outlet } from '@tanstack/react-router'
import PrivateRoute from '@/providers/private-routes'

export const Route = createFileRoute('/_auth/auth/talent-scout')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <PrivateRoute>
        <Outlet />
      </PrivateRoute>
    </>
  )
}
